import * as ko from "knockout";

// Helpers
import "fontAwesomeBindings";

export interface ILoadingBase {
    Message: string | KnockoutObservable<string>;           // Required - Used as the screenreader message when consuming 'icon-loading'
    DisplayCondition: KnockoutObservable<boolean>;          // Required
}

export default class LoadingBase {
    // This is the amount of time, in milliseconds, before the loading message appears.
    // This is to prevent it appearing and disappearing quickly, which is janky.
    loadingAppearanceDelay: number = 750;

    // Params
    message: string | KnockoutObservable<string>;
    externalDisplayCondition: KnockoutObservable<boolean>;

    // Members
    timer: number;
    displayCondition: KnockoutComputed<boolean>;
    displayTimerExpired: KnockoutObservable<boolean>;
    subscription: KnockoutSubscription;

    constructor(params: ILoadingBase) {
        // Component Validation
        if (params.Message == null || params.Message == undefined || params.DisplayCondition == null || params.DisplayCondition == undefined) {
            throw new Error("Please ensure all required properties are provided when referencing any of the 'loading-base' components");
        }

        // Provided Component Properties
        this.message = params.Message;
        this.externalDisplayCondition = params.DisplayCondition;

        this.displayTimerExpired = ko.observable(false);

        if (this.externalDisplayCondition()) {
            this.setupTimer();
        }

        this.setupSubscribes();
        this.setupComputeds();

    }

    private setupTimer() {
        this.displayTimerExpired(false);
        if (this.timer != null) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            this.timer = null;
            this.displayTimerExpired(true);
        }, this.loadingAppearanceDelay);
    }

    private setupSubscribes() {
        this.subscription = this.externalDisplayCondition.subscribe((value: boolean) => {
            if (value) {
                this.setupTimer();
            }
        });
    }

    private setupComputeds() {
        this.displayCondition = ko.pureComputed(() => this.externalDisplayCondition() && this.displayTimerExpired());
    }

    dispose() {
        this.subscription.dispose();
    }
}

const alertComponent = "alert-loading";
ko.components.unregister(alertComponent);
ko.components.register(alertComponent, {
    viewModel: LoadingBase,
    template: { require: `text!/Themes/Default/Content/ts/Shared/Loading/Alert/${alertComponent}.html` }
});

const standardIconComponent = "icon-loading-standard";
ko.components.unregister(standardIconComponent);
ko.components.register(standardIconComponent, {
    viewModel: LoadingBase,
    template: { require: `text!/Themes/Default/Content/ts/Shared/Loading/Icon/${standardIconComponent}.html` }
});

const largeIconComponent = "icon-loading-large";
ko.components.unregister(largeIconComponent);
ko.components.register(largeIconComponent, {
    viewModel: LoadingBase,
    template: { require: `text!/Themes/Default/Content/ts/Shared/Loading/Icon/${largeIconComponent}.html` }
});

const iconOverlayComponent = "icon-loading-overlay";
ko.components.unregister(iconOverlayComponent);
ko.components.register(iconOverlayComponent, {
    viewModel: LoadingBase,
    template: { require: `text!/Themes/Default/Content/ts/Shared/Loading/Overlay/${iconOverlayComponent}.html` }
});